import React, { useContext } from "react";

import { classnames } from "@culturehq/components";
import { Subtitle } from "chq";
import { CreatomateContext } from "../../../../../contexts/VideoStudioContext";
import SubtitleOption from "./SubtitleOption";

interface LanguageSelectorProps {
  changingLanguage: boolean;
  onLanguageChange: (subtitle: Subtitle) => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  changingLanguage, onLanguageChange
}) => {
  const { data: { subtitles } } = useContext(CreatomateContext);

  return (
    <div className={classnames("subtitle-accordian", "nav-tabs")}>
      {subtitles.filter(subtitle => !subtitle.deleted)?.map(subtitle => (
        <SubtitleOption
          activeLanguage={subtitles?.find(subtitle => subtitle.active)?.label}
          changingLanguage={changingLanguage}
          key={subtitle.id}
          subtitle={subtitle}
          onChangeLanguage={onLanguageChange}
        />
      ))}
    </div>
  );
};

export default LanguageSelector;
